import type {
  CruisePriceFilterChangeProps,
} from 'components/Cruises/SearchPage/Filters/Inputs/Common/CruiseSearchExtraFilter/CruisePriceFilter'
import CruisePriceFilter from 'components/Cruises/SearchPage/Filters/Inputs/Common/CruiseSearchExtraFilter/CruisePriceFilter'
import Modal from 'LuxKit/Modal/Modal'
import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import type {
  CruiseSearchPriceChipProps,
} from 'components/Cruises/SearchPage/Filters/Inputs/CruiseSearchMobileChips/CruiseSearchPriceChip'

function ModalCruiseSearchPriceChip(props: CruiseSearchPriceChipProps) {
  const {
    listFilters,
    facets,
    filterForm,
    setFilterForm,
    fetching,
    drawerMode,
  } = props
  const intl = useIntl()
  const modalElement = useModalElementContext<boolean>()

  const closeModal = useCallback(() => {
    modalElement.resolve(true)
  }, [modalElement])

  const resetFilter = useCallback(() => {
    setFilterForm({ ...filterForm, ...{ minPrice: undefined, maxPrice: undefined } })
    closeModal()
  }, [closeModal, filterForm, setFilterForm])

  const updateForm = useCallback((newFormPrice: CruisePriceFilterChangeProps) => {
    if (newFormPrice && Object.keys(newFormPrice).length > 0) {
      setFilterForm({ ...filterForm, ...newFormPrice })
    } else {
      setFilterForm({ ...filterForm, minPrice: undefined, maxPrice: undefined })
    }
  }, [filterForm, setFilterForm])

  const modalTitle = intl.formatMessage({
    id: 'yWJ2CATFTmZ_V5OkIEHN',
    defaultMessage: 'Price',
    description: 'Modal title for cruise price filter in the cruise offer or booking section',
  })
  const applyLabel = intl.formatMessage({
    id: 'dsw-X0YNZS4gyv7usA14',
    defaultMessage: 'Apply',
    description: 'Button text to apply cruise price filter selections',
  })
  const resetLabel = intl.formatMessage({
    id: 'Cyk9aS5lE5-CCtiAyIC7',
    defaultMessage: 'Reset all',
    description: 'Button text to reset cruise price filters in the cruise section',
  })

  return <Modal
    mode={drawerMode ? 'drawer' : 'default'}
    title={modalTitle}
    primaryActionText={applyLabel}
    onPrimaryActionClick={closeModal}
    secondaryActionText={resetLabel}
    onSecondaryActionClick={resetFilter}
  >
    <CruisePriceFilter
      facets={facets}
      filters={listFilters}
      onChange={updateForm}
      fetching={fetching}
    >
    </CruisePriceFilter>
  </Modal>
}

export default ModalCruiseSearchPriceChip
